"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hubspot_svg_1 = __importDefault(require("@ClientAssets/icons/features/hubspot.svg"));
var google_logo_light_svg_1 = __importDefault(require("@ClientAssets/icons/google-logo-light.svg"));
var salesforce_svg_1 = __importDefault(require("@ClientAssets/icons/features/salesforce.svg"));
var microsoft_logo_light_svg_1 = __importDefault(require("@ClientAssets/icons/microsoft-logo-light.svg"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Masthead_1 = __importDefault(require("../Masthead/Masthead"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Fields_1 = require("Common/Form/Fields");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var GatekeeperTelemetry_1 = require("Gatekeeper/GatekeeperTelemetry");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var Common_1 = require("Gatekeeper/Common");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var types_1 = require("@CommonFrontendBackend/User/types");
var Signup = (function (_super) {
    __extends(Signup, _super);
    function Signup(props) {
        var _this = _super.call(this, props) || this;
        _this.showSSO = false;
        _this.allSsoMethods = [
            Types_1.AuthenticationMethod.Google,
            Types_1.AuthenticationMethod.Microsoft,
            Types_1.AuthenticationMethod.Salesforce,
            Types_1.AuthenticationMethod.Hubspot,
        ];
        _this.makeTrackAuthStrategyClicked = function (authStrategy) { return function () {
            _this.gatekeeperTelemetry.track("Selected Signup Authentication Strategy", {
                authentication_strategy: authStrategy,
            });
        }; };
        if (window.localStorage) {
            if (_this.ssoMethodsToShow.length === 0) {
                _this.showSSO = false;
            }
            if (_this.props.authenticationMethods && !_this.props.authenticationMethods.includes("email")) {
                _this.showSSO = true;
            }
            localStorage.setItem("hideSSO", "".concat(!_this.showSSO));
        }
        return _this;
    }
    Signup_1 = Signup;
    Object.defineProperty(Signup.prototype, "ssoMethodsToShow", {
        get: function () {
            var _this = this;
            if (!this.props.authenticationMethods) {
                if (this.props.inviteHash && this.props.inviteAccount) {
                    return this.allSsoMethods;
                }
                else {
                    return this.allSsoMethods.filter(function (method) { return method !== Types_1.AuthenticationMethod.Microsoft; });
                }
            }
            return this.allSsoMethods.filter(function (method) { return _this.props.authenticationMethods.includes(method); });
        },
        enumerable: false,
        configurable: true
    });
    Signup.getAttributionData = function () {
        var cookieVal = (0, Common_1.extractAttributerCookie)(document);
        return cookieVal ? JSON.parse(atob(cookieVal)) : null;
    };
    Signup.prototype.componentDidMount = function () {
        var _this = this;
        this.gatekeeperTelemetry.track("Signup Page Viewed", {
            document_referrer: document.referrer,
        });
        this.disposeShowEmailSignupAutorunner = (0, mobx_1.autorun)(function () {
            if (!_this.showSSO) {
                _this.gatekeeperTelemetry.track("Viewed Signup With Email Step");
            }
        });
    };
    Signup.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.disposeShowEmailSignupAutorunner) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Object.defineProperty(Signup.prototype, "explainerText", {
        get: function () {
            switch (this.props.entryPoint) {
                case types_1.UserSignupEntryPoints.Template:
                    return "Create a Qwilr account to begin editing your template";
                default:
                    return "Let's get started";
            }
        },
        enumerable: false,
        configurable: true
    });
    Signup.prototype.render = function () {
        return (react_1.default.createElement(Masthead_1.default, { explainer: this.explainerText, back: undefined }, this.showSSO ? this.ssoPage : this.formPage));
    };
    Object.defineProperty(Signup.prototype, "formPage", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Form, { fields: [Fields_1.Name, Fields_1.Email, Fields_1.Password], onComplete: this.onComplete, allowDevAutocomplete: this.props.allowDevAutocomplete, buttonText: "Continue" }),
                react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () {
                        _this.setShowSSO(true);
                    } }, "View other signup methods")));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "googleButton", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(kaleidoscope_1.Button, { className: "button__google", openInSameTab: true, onClick: this.makeTrackAuthStrategyClicked(TelemetryAuthStrategy.Google), href: function () {
                    return (0, Common_1.buildSSOUrl)({
                        baseUrl: _this.props.publicApiBaseUrl,
                        authRoute: "/auth/google?action=signup",
                        attributionStr: (0, Common_1.extractAttributerCookie)(document),
                        inviteHash: _this.props.inviteHash,
                        inviteAccountId: _this.props.inviteAccount,
                    });
                } },
                react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: google_logo_light_svg_1.default }),
                "Continue with Google"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "microsoftButton", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(kaleidoscope_1.Button, { className: "button__microsoft", openInSameTab: true, onClick: this.makeTrackAuthStrategyClicked(TelemetryAuthStrategy.Microsoft), href: function () {
                    return (0, Common_1.buildSSOUrl)({
                        baseUrl: _this.props.publicApiBaseUrl,
                        authRoute: "/auth/microsoft?action=signup",
                        attributionStr: (0, Common_1.extractAttributerCookie)(document),
                        inviteHash: _this.props.inviteHash,
                        inviteAccountId: _this.props.inviteAccount,
                    });
                } },
                react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: microsoft_logo_light_svg_1.default }),
                "Continue with Microsoft"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "hubspotButton", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(kaleidoscope_1.Button, { className: "button__hubspot", openInSameTab: true, onClick: this.makeTrackAuthStrategyClicked(TelemetryAuthStrategy.Hubspot), href: function () {
                    return (0, Common_1.buildSSOUrl)({
                        baseUrl: _this.props.publicApiBaseUrl,
                        authRoute: "/auth/hubspot?sso=true&action=signup",
                        attributionStr: (0, Common_1.extractAttributerCookie)(document),
                        inviteHash: _this.props.inviteHash,
                        inviteAccountId: _this.props.inviteAccount,
                    });
                } },
                react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: hubspot_svg_1.default }),
                "Continue with HubSpot"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "salesforceButton", {
        get: function () {
            var _this = this;
            return (react_1.default.createElement(kaleidoscope_1.Button, { className: "button__salesforce", openInSameTab: true, onClick: this.makeTrackAuthStrategyClicked(TelemetryAuthStrategy.Salesforce), href: function () {
                    return (0, Common_1.buildSSOUrl)({
                        baseUrl: _this.props.publicApiBaseUrl,
                        authRoute: "/auth/salesforce?sso=true&action=signup",
                        attributionStr: (0, Common_1.extractAttributerCookie)(document),
                        inviteHash: _this.props.inviteHash,
                        inviteAccountId: _this.props.inviteAccount,
                    });
                } },
                react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: salesforce_svg_1.default }),
                "Continue with Salesforce"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Signup.prototype, "ssoPage", {
        get: function () {
            var _this = this;
            var authenticationMethods = this.props.authenticationMethods;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "masthead__sso" },
                    this.ssoMethodsToShow.includes(Types_1.AuthenticationMethod.Google) && this.googleButton,
                    this.ssoMethodsToShow.includes(Types_1.AuthenticationMethod.Salesforce) && this.salesforceButton,
                    this.ssoMethodsToShow.includes(Types_1.AuthenticationMethod.Hubspot) && this.hubspotButton,
                    this.ssoMethodsToShow.includes(Types_1.AuthenticationMethod.Microsoft) && this.microsoftButton),
                (!authenticationMethods || authenticationMethods.includes(Types_1.AuthenticationMethod.Email)) && (react_1.default.createElement("div", { className: "masthead__alt" },
                    "Or",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () {
                            _this.setShowSSO(false);
                            _this.makeTrackAuthStrategyClicked(TelemetryAuthStrategy.Email)();
                        } }, "continue with email")))));
        },
        enumerable: false,
        configurable: true
    });
    Signup.prototype.onComplete = function (_a) {
        var name = _a.name, email = _a.email, password = _a.password;
        return __awaiter(this, void 0, Promise, function () {
            var names, requestBody, attributionData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        names = name.split(" ");
                        requestBody = __assign(__assign({ firstName: names[0] }, (names.length > 1 ? { lastName: names.slice(1, names.length).join(" ") } : {})), { email: email, password: password });
                        attributionData = Signup_1.getAttributionData();
                        if (attributionData) {
                            requestBody = (0, lodash_1.merge)(requestBody, { attributionData: attributionData });
                        }
                        if (this.props.inviteHash) {
                            requestBody.inviteHash = this.props.inviteHash;
                        }
                        if (this.props.inviteAccount) {
                            requestBody.inviteAccount = this.props.inviteAccount;
                        }
                        return [4, this.props.onComplete(requestBody)];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    Signup.prototype.setShowSSO = function (showSSO) {
        this.showSSO = showSSO;
        if (window.localStorage) {
            localStorage.setItem("hideSSO", "".concat(!this.showSSO));
        }
    };
    var Signup_1, _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Signup.prototype, "showSSO", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof GatekeeperTelemetry_1.GatekeeperTelemetry !== "undefined" && GatekeeperTelemetry_1.GatekeeperTelemetry) === "function" ? _a : Object)
    ], Signup.prototype, "gatekeeperTelemetry", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Signup.prototype, "formPage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Signup.prototype, "ssoPage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], Signup.prototype, "onComplete", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Signup.prototype, "setShowSSO", null);
    Signup = Signup_1 = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Signup);
    return Signup;
}(react_1.default.Component));
var TelemetryAuthStrategy;
(function (TelemetryAuthStrategy) {
    TelemetryAuthStrategy["Hubspot"] = "hubspot";
    TelemetryAuthStrategy["Salesforce"] = "salesforce";
    TelemetryAuthStrategy["Microsoft"] = "microsoft";
    TelemetryAuthStrategy["Google"] = "google";
    TelemetryAuthStrategy["Email"] = "email";
})(TelemetryAuthStrategy || (TelemetryAuthStrategy = {}));
exports.default = Signup;
